import { render, staticRenderFns } from "./contractMessages.vue?vue&type=template&id=71963d46&scoped=true&"
import script from "./contractMessages.vue?vue&type=script&lang=js&"
export * from "./contractMessages.vue?vue&type=script&lang=js&"
import style0 from "./contractMessages.vue?vue&type=style&index=0&id=71963d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71963d46",
  null
  
)

export default component.exports